export default __webpack_public_path__ + "static/media/CheckCircle.b0186db1.svg";